import React from "react"

import styled from "styled-components"

const Option = styled.div `
  height: 50px;
  padding: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #757575;
  input {
    margin:0 1%;
  }
  .multiOption_checkmark {
    height: 19px;
    width: 19px;
    margin: 0 10px;
    padding: 5px;
    border-radius: 3px;
    border: 1px solid #757575;
    background-color: ${({selected, checkmarkColor}) => selected ? checkmarkColor : 'transparent'};
    position: relative;
    &:after {
      position: absolute;
      display: ${({selected}) => selected ? "block" : "none"};
      content: "";
      left: 6px;
      top: 3px;
      width: 3px;
      height: 6px;
      border: solid white;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
  .multiOption_label {
    max-height: 50px;
    overflow: hidden;
    line-height: 25px;
    text-overflow: ellipsis;
  }
  &:hover {
    .multiOption_checkmark {
      background-color: ${({checkmarkColor}) => checkmarkColor ? checkmarkColor : "black"};
      opacity: ${({selected}) => selected ? 1 : 0.3 };
      &:after {
        display: block;
      }
      padding: 5px;
    }
  }
`

const CustomMultiOption = props => {
  const { data, getValue, selectOption, selectProps } = props

  const { checkmarkColor } = selectProps.customMultiOptionProps

  const selectedOptions = getValue()
  const dataIsSelected = selectedOptions.findIndex(
    (option) => option.value === data.value
  ) !== -1

  return (
    <Option
      data-testid="testoption"
      selected={dataIsSelected}
      checkmarkColor={checkmarkColor}
      onClick={() => selectOption(data)}
    >
      <div className="multiOption_checkmark"/>
      <div className="multiOption_label">{data.label}</div>
    </Option>
  )
}

export default CustomMultiOption
